
export const resetAuth = () => async (dispatch) => {
    dispatch({ type: 'RESET_STATE' });
};